import React from 'react'
import deleteCampaignLink from '../../../api/marketing/deleteCampaignLink'
import DeletePopUp from '../../../ui/PopUp/DeletePopUp/DeletePopUp'

function DeleteCampaignLinkPopUp({ link, closePopUp, onError }) {
  const linkLabel = link.title || link.shortUrl || link.id

  const submitDelete = () =>
    deleteCampaignLink(link.id).then((result) => {
      if (!result.ok) {
        onError?.(result.message)
        throw new Error(result.message)
      }
    })

  return (
    <DeletePopUp
      title="Видалити посилання"
      warningMessage={
        <>
          Ви впевнені, що хочете видалити посилання <span className="Bolder">"{linkLabel}"</span>?
        </>
      }
      closePopUp={closePopUp}
      submitDelete={submitDelete}
    />
  )
}

export default DeleteCampaignLinkPopUp
